import PlateAppearanceResult from "../../enums/PlateAppearanceResult.js";

// @see https://www.mlb.com/glossary/standard-stats/intentional-walk
// An intentional walk occurs when the defending team elects to walk a batter on purpose, putting him on first base instead of letting him try to hit. Intentional walks -- which count as a walk for the hitter and a walk allowed by the pitcher -- are an important strategy in the context of a game. They can be used to put a runner on first base, setting up a potential double play.
const classifiesAsIntentionalWalk = function(paResult) {
    switch (paResult) {
        case PlateAppearanceResult.IntentionalWalk.key:
        //case PlateAppearanceResult.Unidentified.key:
            return true;

        default:
            return false;
    }
};

export default classifiesAsIntentionalWalk;